import React from 'react';
import { View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import styles from './generic-activity.style';
import { useActivityContext } from '../../../hooks/use-activity.context';
import { AudioPlayerWithProvider } from '../../audio-player/audio-player-with-provider';
import { Button } from '../../button/button';
import { ContinueButton } from '../../continue-button/continue-button';
import { Instruction } from '../../instruction/instruction.component';
import { Title } from '../../title/title.component';
import { TranslatableText } from '../../translatable-text/translatable-text';
import { Card } from '../card/card';
import { CardHeader } from '../card/card-header/card-header';

export function GenericActivity() {
  const {
    currentActivity,
    goNext,
    currentStepIndex,
    completeCurrentStep,
    currentSteps,
    isCurrentStepComplete,
    isCurrentActivityComplete,
  } = useActivityContext();

  const totalSteps = currentSteps?.length;

  return (
    <>
      <SafeAreaView edges={['bottom']} style={styles.container}>
        <View style={styles.section}>
          <Title>Generic Activity</Title>
          <View style={styles.instructions}>
            <Instruction
              text={`Generic Activity with ${totalSteps} step${
                (totalSteps > 1 && 's') || ''
              }`}
            />
          </View>
          <Card>
            <CardHeader>
              <AudioPlayerWithProvider url="https://www.kozco.com/tech/piano2-CoolEdit.mp3" />
            </CardHeader>
            <TranslatableText translation="Suceda ocioso iba non merced era. Celo ah mana duda dona lire os gris. El encima abuelo se reales. Gr llanura levanto ve blancas si velando primero. Con sin reprimenda candilejas expresivas terciopelo electricas hoy mil. Mal mal uso pertenecia cualquiera entusiasmo espontanea los. Acuerdo oh ti ni calmoso echarse parecer absurdo de. Mana las mal una odio poca esas hay ante. Sus recurso mas asi llegado ido sobrado emplear conocia secreto. Da echando verdura segundo pequeno ve colchon al. ">
              Seen you eyes son show. Far two unaffected one alteration
              apartments celebrated but middletons interested. Described
              deficient applauded consisted my me do. Passed edward two talent
              effect seemed engage six. On ye great do child sorry lived.
              Proceed cottage far letters ashamed get clothes day. Stairs regret
              at if matter to. On as needed almost at basket remain. By improved
              sensible servants children striking in surprise.
            </TranslatableText>
          </Card>
        </View>

        <View
          style={[
            styles.checkSection,
            // eslint-disable-next-line react-native/no-inline-styles
            { opacity: isCurrentActivityComplete ? 0 : 1 },
          ]}
        >
          <Button onPress={completeCurrentStep}>
            {totalSteps > 1 ? `Check Step ${currentStepIndex + 1}` : 'Check'}
          </Button>
        </View>
      </SafeAreaView>
      {isCurrentStepComplete && (
        <ContinueButton
          feedback={currentActivity.correctFeedback}
          onPress={goNext}
        />
      )}
    </>
  );
}
